module.exports = __webpack_public_path__ + "static/img/dummy-hierarchy.b407fa3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app-manager/img/dummy-hierarchy.svg
// module id = 1Lpb
// module chunks = 46